import { IMenuItem } from '../../models/menu.model';

export const clientMenu: IMenuItem = {
  label: `Client`,
  path: `client-desk`,
  id: 'MID_CLIENT_DESK',
  icon: 'fa fa-cogs',
  children: [
    {
      path: `find`,
      label: `Client Data`,
      id: 'MID_CLIENT_FIND',
    },
    {
      path: `entities`,
      label: `Client Entities`,
      id: 'MID_CLIENT_ENTITIES',
    },
    { path: `fraud`, label: `Fraud`, id: 'MID_CLIENT_FRAUD' },
  ],
};
